import type { FrontendWidget } from '../types';
import { CollapsibleBlockComponent } from './CollapsibleBlockComponent';
import type { CollapsibleBlockConfig, CollapsibleBlockResolved } from './types';

export const collapsibleBlockWidget: FrontendWidget<
  CollapsibleBlockConfig,
  CollapsibleBlockResolved
> = {
  componentType: 'layouts.collapsible-block',
  // 70.14: SlotRenderer adds no container — contains its own blocks, and its heading and body share one container.
  layout: 'self',
  displayName: 'Collapsible Block',
  ComponentA: CollapsibleBlockComponent,
  resolveSync: (config) => ({
    title: config.title ?? '',
    blocks: config.blocks ?? [],
    anchorId: config.anchorId,
    forbidClosing: config.forbidClosing === true,
  }),
};
